import React from 'react'
import { business_categories } from 'hotline_complaint_choices'
import { ReviewItems } from '../ReviewItems'
import { formatAddress, formatReviewString } from '../../utilities'
import {
  addressLabel,
  businessCategoryLabel,
  businessNameLabel,
  dbaLabel,
  einLabel,
  npiLabel,
  businessPhoneLabel,
  alternatePhoneLabel,
  websiteLabel
} from '../../strings/labels'

export const ReviewSubjectBusiness = ({
  address,
  address2,
  city,
  state,
  zip,
  country,
  business_name,
  business_category,
  dba,
  ein,
  npi,
  phone,
  phone2,
  website,
  description,
  subject_type,
  editFieldName,
  onClick
}) => {
  let business_details = [
    {
      heading: 'Type of subject',
      field_name: 'subject_type',
      value: formatReviewString(subject_type)
    },
    {
      heading: businessNameLabel,
      value: formatReviewString(business_name)
    },
    {
      heading: businessCategoryLabel,
      value: formatReviewString(business_categories[business_category])
    },
    {
      heading: dbaLabel,
      value: formatReviewString(dba)
    },
    {
      heading: einLabel,
      value: formatReviewString(ein)
    },
    {
      heading: npiLabel,
      value: formatReviewString(npi)
    },
    {
      heading: addressLabel,
      value: formatReviewString(
        formatAddress({
          line1Value: address,
          line2Value: address2,
          cityValue: city,
          stateValue: state,
          zipValue: zip,
          countryValue: country
        })
      )
    },
    {
      heading: businessPhoneLabel,
      value: formatReviewString(phone)
    },
    {
      heading: alternatePhoneLabel,
      value: formatReviewString(phone2)
    },
    {
      heading: websiteLabel,
      value: formatReviewString(website)
    },
    {
      heading: 'Additional identifying information',
      value: formatReviewString(description)
    }
  ]

  const addCommonProps = items =>
    items.map(item => {
      return {
        ...item,
        field_name: editFieldName,
        onClick
      }
    })

  business_details = addCommonProps(business_details)

  return <ReviewItems items={business_details} />
}
